import "@/App.css";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { Founder } from "./components/Founder";
import { Process } from "./components/Process";
import { Testimonials } from "./components/Testimonials";
import { CTASection } from "./components/CTASection";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { FloatingButtons } from "./components/FloatingButtons";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Founder />
        <Process />
        <Testimonials />
        <CTASection />
        <Contact />
      </main>
      <Footer />
      <FloatingButtons />
      <Toaster
        theme="dark"
        position="bottom-left"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            border: "1px solid rgba(182,245,0,0.4)",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}

export default App;
